/* One local catalogue, shared by the header finder and the A-Z directory. */
(() => {
  'use strict';
  if (window.GBSBrandMenu) { window.GBSBrandMenu.init(); return; }
  const ready = new WeakSet();
  const root = document.documentElement;
  let brands = [], fitFrame = 0, compactDrawer = null;
  let returningHalifaxFocus = false;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]/g, '');
  const alphabetical = (a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base', numeric: true });
  const matching = query => {
    const needle = normalize(query);
    return brands.filter(brand => brand.search.some(value => value.includes(needle))).sort(alphabetical);
  };
  function readCatalogue() {
    const source = document.getElementById('GbsBrandCatalogue');
    try {
      const rows = JSON.parse(source ? source.textContent : '[]');
      brands = Array.isArray(rows) ? rows.filter(row => row && row.name && row.url && row.logo).map(row => ({
        ...row,
        search: [row.name, ...(Array.isArray(row.aliases) ? row.aliases : [])].map(normalize)
      })) : [];
    } catch (error) { brands = []; console.warn('Brand navigation catalogue could not be read.'); }
  }
  function tile(brand) {
    const link = document.createElement('a');
    link.className = 'gbs-brand-tile';
    link.href = brand.url;
    link.setAttribute('aria-label', `Shop ${brand.name}`);
    const frame = document.createElement('span');
    frame.className = 'gbs-brand-logo';
    const logo = document.createElement('img');
    logo.src = brand.logo;
    logo.alt = '';
    logo.loading = 'lazy';
    logo.decoding = 'async';
    if (brand.monochrome === true) logo.style.filter = 'brightness(0)';
    if (Number.isFinite(Number(brand.logoMaxWidth)) && Number(brand.logoMaxWidth) > 0) logo.style.maxWidth = `${Math.max(40, Math.min(200, Number(brand.logoMaxWidth)))}px`;
    const scale = Math.max(1, Math.min(4, Number(brand.logoScale) || 1));
    const offsetX = Math.max(-35, Math.min(35, Number(brand.logoOffsetX) || 0));
    const offsetY = Math.max(-35, Math.min(35, Number(brand.logoOffsetY) || 0));
    if (scale !== 1 || offsetX || offsetY) logo.style.transform = `translate(${offsetX}%, ${offsetY}%) scale(${scale})`;
    if (Number(brand.logoWidth) > 0) logo.width = Number(brand.logoWidth);
    if (Number(brand.logoHeight) > 0) logo.height = Number(brand.logoHeight);
    frame.append(logo);
    const name = document.createElement('span');
    name.className = 'gbs-brand-name';
    name.textContent = brand.name;
    link.append(frame, name);
    return link;
  }
  function fill(container, rows) {
    if (!container) return;
    const fragment = document.createDocumentFragment();
    rows.forEach(brand => fragment.append(tile(brand)));
    container.replaceChildren(fragment);
  }
  function initBrowser(browser) {
    if (ready.has(browser)) return;
    ready.add(browser);
    const featured = brands.filter(brand => Number(brand.rank) > 0).sort((a, b) => a.rank - b.rank || alphabetical(a, b));
    fill(browser.querySelector('[data-gbs-brand-featured]'), featured.slice(0, 10));
    const input = browser.querySelector('[data-gbs-brand-search]');
    const results = browser.querySelector('[data-gbs-brand-results]');
    const status = browser.querySelector('[data-gbs-brand-status]');
    const all = browser.querySelector('[data-gbs-brand-all]');
    const allUrl = all.getAttribute('href');
    input.addEventListener('input', () => {
      const query = input.value.trim();
      const rows = query ? matching(query) : [];
      fill(results, rows);
      results.hidden = !query || !rows.length;
      status.textContent = query ? (rows.length ? `${rows.length} ${rows.length === 1 ? 'brand' : 'brands'} found` : 'No brands found. Try another name.') : '';
      all.href = query ? `${allUrl}&brand=${encodeURIComponent(query)}` : allUrl;
    });
  }
  function closeDesktop(except) {
    document.querySelectorAll('[data-gbs-brand-desktop][open]').forEach(details => {
      if (details !== except) details.open = false;
    });
  }
  function dismissHalifax(returnFocus = false) {
    document.querySelectorAll('.gbh-nav-item').forEach(item => {
      item.classList.add('gbs-nav-dropdown-dismissed');
      if (returnFocus && item.getClientRects().length) {
        returningHalifaxFocus = true;
        item.querySelector('.gbh-nav-trigger')?.focus({ preventScroll: true });
        returningHalifaxFocus = false;
      } else if (item.contains(document.activeElement)) document.activeElement.blur();
    });
  }
  function initHalifax(item) {
    if (ready.has(item)) return;
    ready.add(item);
    item.addEventListener('pointerenter', () => {
      item.classList.remove('gbs-nav-dropdown-dismissed');
      closeDesktop();
    });
    item.addEventListener('focusin', () => {
      if (!returningHalifaxFocus) {
        item.classList.remove('gbs-nav-dropdown-dismissed');
        closeDesktop();
      }
    });
  }
  function initDesktop(details) {
    if (ready.has(details)) return;
    ready.add(details);
    const summary = details.querySelector('summary');
    let enterTimer, leaveTimer;
    summary.setAttribute('aria-expanded', String(details.open));
    details.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(details.open));
      if (details.open) { closeDesktop(details); dismissHalifax(); }
    });
    details.addEventListener('pointerenter', event => {
      clearTimeout(leaveTimer);
      if (event.pointerType === 'mouse' && matchMedia('(hover:hover) and (pointer:fine)').matches) {
        enterTimer = setTimeout(() => { closeDesktop(details); details.open = true; }, 100);
      }
    });
    details.addEventListener('pointerleave', () => {
      clearTimeout(enterTimer);
      leaveTimer = setTimeout(() => { if (!details.contains(document.activeElement)) details.open = false; }, 140);
    });
    details.addEventListener('focusout', () => {
      setTimeout(() => { if (!details.contains(document.activeElement) && !details.matches(':hover')) details.open = false; }, 0);
    });
    summary.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        closeDesktop(details);
        details.open = true;
        details.querySelector('.gbs-brand-dropdown a, .gbs-brand-dropdown input')?.focus();
      }
    });
  }
  function resetMobile(content, focus = false) {
    const view = content.querySelector('.gbs-brand-mobile-view');
    const trigger = content.querySelector('[data-gbs-brand-mobile-trigger]');
    content.classList.remove('gbs-brand-mobile-active');
    if (view) view.hidden = true;
    trigger?.setAttribute('aria-expanded', 'false');
    if (focus) trigger?.focus();
  }
  function initMobile(content) {
    if (ready.has(content)) return;
    ready.add(content);
    const trigger = content.querySelector('[data-gbs-brand-mobile-trigger]');
    const view = content.querySelector('.gbs-brand-mobile-view');
    if (!trigger || !view) return;
    trigger.addEventListener('click', () => {
      content.classList.add('gbs-brand-mobile-active');
      trigger.setAttribute('aria-expanded', 'true');
      view.hidden = false;
      view.querySelector('[data-gbs-brand-search]').focus();
      const panel = content.closest('[data-mobile-nav-panel]');
      if (panel) panel.scrollTop = 0;
    });
    view.querySelector('[data-gbs-brand-back]').addEventListener('click', () => resetMobile(content, true));
    const drawer = content.closest('[data-mobile-nav]');
    if (drawer) new MutationObserver(() => {
      if (drawer.dataset.open !== 'true') resetMobile(content);
    }).observe(drawer, { attributes: true, attributeFilter: ['data-open'] });
  }
  function initDirectory(directory) {
    if (ready.has(directory)) return;
    ready.add(directory);
    const input = directory.querySelector('[data-gbs-brand-directory-search]');
    const groups = directory.querySelector('[data-gbs-brand-directory-groups]');
    const letters = directory.querySelector('[data-gbs-brand-letters]');
    const status = directory.querySelector('[data-gbs-brand-directory-status]');
    const update = () => {
      const query = input.value.trim();
      const rows = matching(query);
      const grouped = new Map();
      rows.forEach(brand => {
        const first = brand.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').charAt(0).toUpperCase();
        const letter = /[A-Z]/.test(first) ? first : '#';
        if (!grouped.has(letter)) grouped.set(letter, []);
        grouped.get(letter).push(brand);
      });
      const groupFragment = document.createDocumentFragment();
      const letterFragment = document.createDocumentFragment();
      grouped.forEach((items, letter) => {
        const section = document.createElement('section');
        section.className = 'gbs-brand-letter-group';
        section.id = `${directory.id || 'GbsBrands'}-letter-${letter === '#' ? 'number' : letter}`;
        const heading = document.createElement('h2');
        heading.textContent = letter;
        const grid = document.createElement('div');
        grid.className = 'gbs-brand-grid gbs-brand-directory-grid';
        fill(grid, items);
        section.append(heading, grid);
        groupFragment.append(section);
        const jump = document.createElement('a');
        jump.href = `#${section.id}`;
        jump.textContent = letter;
        jump.setAttribute('aria-label', `Brands starting with ${letter}`);
        letterFragment.append(jump);
      });
      groups.replaceChildren(groupFragment);
      letters.replaceChildren(letterFragment);
      status.textContent = rows.length ? `${rows.length} ${rows.length === 1 ? 'brand' : 'brands'}${query ? ' found' : ''}` : 'No brands found. Try another name.';
    };
    input.value = new URLSearchParams(location.search).get('brand') || '';
    input.addEventListener('input', update);
    update();
  }
  // Empire opens its drawer only below 1024px. Reuse that drawer, without
  // changing global breakpoints, when this header's actual links need more room.
  function closeCompact(focus = true) {
    if (!compactDrawer) return;
    const state = compactDrawer;
    compactDrawer = null;
    state.drawer.dataset.open = 'false';
    state.panel.dataset.animationState = 'closed';
    state.overlay.dataset.animationState = 'closed';
    state.button.classList.remove('active');
    state.button.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = state.bodyOverflow;
    root.style.overflow = state.rootOverflow;
    if (state.announcement) {
      if (state.announcementIndex) state.announcement.style.setProperty('--index-announcement-bar', state.announcementIndex, state.announcementPriority);
      else state.announcement.style.removeProperty('--index-announcement-bar');
    }
    ['role', 'aria-modal', 'aria-label'].forEach(name => {
      if (state.attributes[name] === null) state.drawer.removeAttribute(name);
      else state.drawer.setAttribute(name, state.attributes[name]);
    });
    if (focus && state.button.isConnected) state.button.focus();
  }
  function openCompact(button) {
    const header = button.closest('[data-section-type="static-header"]')?.parentElement || document;
    const drawer = header.querySelector('[data-mobile-nav]') || document.querySelector('[data-mobile-nav]');
    if (!drawer) return;
    const panel = drawer.querySelector('[data-mobile-nav-panel]');
    const overlay = drawer.querySelector('[data-mobile-nav-overlay]');
    const announcement = document.querySelector('[data-announcement-bar]');
    compactDrawer = { drawer, panel, overlay, button, bodyOverflow: document.body.style.overflow, rootOverflow: root.style.overflow,
      announcement, announcementIndex: announcement?.style.getPropertyValue('--index-announcement-bar') || '', announcementPriority: announcement?.style.getPropertyPriority('--index-announcement-bar') || '',
      attributes: { role: drawer.getAttribute('role'), 'aria-modal': drawer.getAttribute('aria-modal'), 'aria-label': drawer.getAttribute('aria-label') } };
    drawer.dataset.open = 'true';
    panel.dataset.animationState = 'open';
    overlay.dataset.animationState = 'open';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Navigation menu');
    announcement?.style.setProperty('--index-announcement-bar', '1100');
    button.classList.add('active');
    button.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    root.style.overflow = 'hidden';
    drawer.focus();
  }
  function measureFit() {
    fitFrame = 0;
    root.classList.remove('gbs-brand-nav-compact');
    if (innerWidth < 990) { closeCompact(false); return; }
    if (innerWidth < 1024) { root.classList.add('gbs-brand-nav-compact'); closeCompact(false); return; }
    const list = document.querySelector('.gbs-brand-nav-item')?.parentElement;
    if (!list) return;
    const wrapper = list.closest('[data-site-navigation]');
    if (!wrapper) return;
    const oldDisplay = wrapper.style.display;
    const oldVisibility = wrapper.style.visibility;
    wrapper.style.visibility = 'hidden';
    wrapper.style.display = 'block';
    const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
    const items = Array.from(list.children);
    const required = items.reduce((total, item) => total + item.getBoundingClientRect().width, 0) + Math.max(0, items.length - 1) * gap;
    const fits = Number.isFinite(required) && required > 0 && list.clientWidth > 0 && required <= list.clientWidth + 1;
    wrapper.style.display = oldDisplay;
    wrapper.style.visibility = oldVisibility;
    root.classList.toggle('gbs-brand-nav-compact', !fits);
    if (fits) closeCompact(false);
  }
  function scheduleFit() { if (!fitFrame) fitFrame = requestAnimationFrame(measureFit); }
  function init() {
    if (compactDrawer && !compactDrawer.drawer.isConnected) closeCompact(false);
    if (!document.querySelector('[data-gbs-nav-backdrop]')) {
      const backdrop = document.createElement('div');
      backdrop.className = 'gbs-nav-backdrop';
      backdrop.dataset.gbsNavBackdrop = '';
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.append(backdrop);
    }
    readCatalogue();
    document.querySelectorAll('[data-gbs-brand-browser]').forEach(initBrowser);
    document.querySelectorAll('[data-gbs-brand-desktop]').forEach(initDesktop);
    document.querySelectorAll('.gbh-nav-item').forEach(initHalifax);
    document.querySelectorAll('[data-mobile-nav-content]').forEach(initMobile);
    document.querySelectorAll('[data-gbs-brand-directory]').forEach(initDirectory);
    scheduleFit();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-menu-toggle]');
    if (!event.target.closest('.gbh-nav-item')) dismissHalifax();
    if (button) closeDesktop();
    if (button && innerWidth >= 1024 && root.classList.contains('gbs-brand-nav-compact')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      compactDrawer ? closeCompact() : openCompact(button);
      return;
    }
    if (compactDrawer && event.target.closest('[data-mobile-nav-close], [data-mobile-nav-overlay]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeCompact();
      return;
    }
    if (!event.target.closest('[data-gbs-brand-desktop]')) closeDesktop();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const details = event.target.closest('[data-gbs-brand-desktop][open]') || document.querySelector('[data-gbs-brand-desktop][open]');
      if (details) { event.preventDefault(); event.stopImmediatePropagation(); details.open = false; details.querySelector('summary').focus(); return; }
      const halifax = Array.from(document.querySelectorAll('.gbh-nav-item:not(.gbs-nav-dropdown-dismissed) .gbh-nav-dropdown')).find(dropdown => dropdown.getClientRects().length);
      if (halifax) { event.preventDefault(); event.stopImmediatePropagation(); dismissHalifax(true); return; }
      const mobile = event.target.closest('.gbs-brand-mobile-active');
      if (mobile) { event.preventDefault(); event.stopImmediatePropagation(); resetMobile(mobile, true); return; }
      if (compactDrawer) { event.preventDefault(); event.stopImmediatePropagation(); closeCompact(); return; }
    }
    if (event.key === 'Tab' && compactDrawer) {
      const focusable = Array.from(compactDrawer.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, [tabindex="0"]')).filter(node => node.getClientRects().length && !node.closest('[hidden]'));
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (!first) return;
      if (event.shiftKey && (document.activeElement === first || !compactDrawer.panel.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !compactDrawer.panel.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
  }, true);
  window.addEventListener('resize', scheduleFit, { passive: true });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => { closeCompact(false); scheduleFit(); });
  if (document.fonts?.ready) document.fonts.ready.then(scheduleFit);
  window.GBSBrandMenu = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
